import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FeedcacheService {
  private sectionsCache: any[] | null = null;
  private primeChannelsCache: any[] | null = null;
  private continueWatchingCache: any[] | null = null;

  setSections(sections: any[]) {
    this.sectionsCache = sections;
  }
  getSections(): any[] | null {
    return this.sectionsCache;
  }

  setPrimeChannels(channels: any[]) {
    this.primeChannelsCache = channels;
  }
  getPrimeChannels(): any[] | null {
    return this.primeChannelsCache;
  }

  setContinueWatching(data: any[]) {
    this.continueWatchingCache = data;
  }
  getContinueWatching(): any[] | null {
    return this.continueWatchingCache;
  }
}